/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import t from"react";function e(){const[e,o]=t.useState(!1),a=t.useCallback((async t=>{if("string"==typeof t||"number"==typeof t)try{await navigator.clipboard.writeText(t),o(!0)}catch(t){console.error("Failed to copy: ",t)}}),[]);return t.useEffect((()=>{e&&setTimeout((()=>{o(!1)}),2e3)}),[e]),{copyToClipboard:a,hasCopied:e}}export{e as default};
//# sourceMappingURL=useCopyToClipboard.js.map
